import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap-v5";
import { MdDeleteForever, MdEdit } from "react-icons/md";
import { useHistory } from "react-router";
import { toast } from "react-toastify";
import Loader from "../../Components/Loader";
import HsCodeRemarkService from "../../Services/HsCodeRemarkService";
import { EditHsCodeRemarks } from "./EditHsCodeRemarks";
import { AddHsCodeRemarks } from "./AddHsCodeRemarks";
import { locationServices } from "../../Services";
import { Modal as delmodal } from "../../Components";

// import { EditHsCodeAdditionalFees } from "./EditHsCodeAdditionalFees";

export const HsCodeRemarks = () => {
  const [data, setData] = useState([]);
  const history = useHistory();
  const [loader, setLoader] = useState(true);
  const [show, setShow] = useState(false);
  const [addmodalshow, setAddmodalshow] = useState(false);
  const [item, setItem] = useState("");
  const [countryList, setCountryList] = useState([]);
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);

  const handleClose = () => setShow(false);
  const handleAddmodalclose = () => setAddmodalshow(false);

  const getData = () => {
    setLoader(true);
    HsCodeRemarkService.getHscoderemarks().then((res) => {
      if (res.status) {
        setData(res.data);
        setLoader(false);
      } else {
        setLoader(false);
        toast.error(res.message);
      }
    });
  };

  useEffect(() => {
    getData();
  }, []);

  const getCountryList = () => {
    locationServices.getCountry().then((res) => {
      if (res.status) {
        let arry = res.data.map((list) => ({
          value: list._id,
          label: list.country_name,
          data: list,
        }));
        setCountryList(arry);
      } else {
        toast.error(res.message);
      }
    });
  };

  const onDeleteSubmit = () => {
    let postData = {
      id: isDeleteOpen,
      // is_deleted: true
    };
    HsCodeRemarkService.deleteHscoderemark(postData)
      .then((res) => {
        if (res.status) {
          toast.success(res.msg);
          setIsDeleteOpen(false);
          getData();
        }
      })
      .catch((error) => {
        console.log(error, "error");
      });
  };

  useEffect(() => {
    getCountryList();
  }, []);

  return (
    <div className="container-fluid">
      <div className="white_box h-100">
        <div className="col-lg-12 col-md-4 mt-4">
          <div className="card p-2 h-100">
            <div className="card-body">
              {/* {loader && <Loader isShow={loader} />}   */}
              <div className="d-flex justify-content-end mb-3">
                <button
                  // className="btn btn-primary btn-sm w-sm waves-effect waves-light col-1"
                  className="btn btn-primary w-sm waves-effect waves-light"
                  onClick={() => setAddmodalshow(true)}
                  // onClick={() => history.push("/add-hs-code-remarks")}
                >
                  Add
                </button>
              </div>
              <div className="table-responsive">
                <>
                  <table className="table table-centered table-nowrap mb-0 border text-center">
                    <thead className="table-light">
                      <tr>
                        <th>Country</th>
                        <th>HS Code</th>
                        <th>Remarks</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.map((item, index) => {
                        return item.data.map((itm, idx) => {
                          return (
                            <tr key={idx}>
                              {idx === 0 && (
                                <td
                                  style={{
                                    borderRight: "1px solid #dfd4d4",
                                    borderBottom:
                                      "1px solid rgb(223, 212, 212)",
                                  }}
                                  className="w-25 bg-white"
                                  rowSpan={item.data.length}
                                >
                                  {item.country_name}
                                </td>
                              )}
                              <td>{itm.hs_code}</td>
                              <td>{itm.remarks}</td>
                              <td>
                                <MdEdit
                                  className="pointer"
                                  onClick={() => {
                                    setShow(true);
                                    setItem(itm);
                                  }}
                                  color="#0323fe"
                                  size="25px"
                                />
                                <MdDeleteForever
                                  className="pointer"
                                  color="red"
                                  size="25px"
                                  onClick={() => setIsDeleteOpen(itm._id)}
                                />
                              </td>
                            </tr>
                          );
                        });
                      })}
                    </tbody>
                  </table>
                </>

                {/* ) : (
                              <div className="w-10 text-center mt-2">
                                Data Not Available
                              </div>
                            )} */}
              </div>
            </div>
          </div>
        </div>
        {/* Edit---------------------------------------------------------------------- */}

        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton className="pt-2 pb-0">
            <Modal.Title>
              <h5>Edit HS Code Remarks</h5>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <EditHsCodeRemarks
              item={item}
              setShow={setShow}
              getData={getData}
            />
          </Modal.Body>
        </Modal>

        {/* add---------------------------------------------------------------------- */}
        <Modal show={addmodalshow} onHide={handleAddmodalclose}>
          <Modal.Header closeButton className="pt-2 pb-0">
            <Modal.Title>
              <h5>Add HS Code Remarks</h5>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <AddHsCodeRemarks
              setAddmodalshow={setAddmodalshow}
              getData={getData}
              countryList={countryList}
              setCountryList={setCountryList}
            />
          </Modal.Body>
        </Modal>
      </div>

      {/* delete---------------------------------------------------- */}
      {Boolean(isDeleteOpen) && (
        <delmodal.DeleteItem
          isOpen={Boolean(isDeleteOpen)}
          title="Delete"
          message={`Are you sure want to Delete`}
          onSubmitEvent={() => onDeleteSubmit()}
          handleClose={() => setIsDeleteOpen(false)}
        />
      )}
      <Loader isShow={loader} />
    </div>
  );
};
